/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CarouselModule } from 'primeng/carousel';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { SpinnerModule } from 'primeng/spinner';
import { AutocompleteComponent } from './component/autocomplete/autocomplete.component';
import { DialogOperationComponent } from './component/dialog-operation/dialog-operation.component';
import { LmsBreExceptionComponent } from './component/lms-bre-exception/lms-bre-exception.component';
import { LmsCarouselComponent } from './component/lms-carousel/lms-carousel.component';
import { LmsDropdownComponent } from './component/lms-dropdown/lms-dropdown.component';
import { LmsFooterComponent } from './component/lms-footer/lms-footer.component';
import { LmsHeaderComponent } from './component/lms-header/lms-header.component';
import { LmsIntendedUsageComponent } from './component/lms-intended-usage/lms-intended-usage.component';
import { LmsLocoUpdateIntUsageComponent } from './component/lms-loco-update-int-usage/lms-loco-update-int-usage.component';
import { LmsMenuItemComponent } from './component/lms-menu-item/lms-menu-item.component';
import { LmsMessageComponent } from './component/lms-message/lms-message.component';
import { LmsPageComponent } from './component/lms-page/lms-page.component';
import { LmsSearchPanelComponent } from './component/lms-search-panel/lms-search-panel.component';
import { LmsSideNavigationComponent } from './component/lms-side-navigation/lms-side-navigation.component';
import { LmsSubmenuItemComponent } from './component/lms-submenu-item/lms-submenu-item.component';
import { LmsTabComponent } from './component/lms-tab/lms-tab.component';
import { LmsTabsComponent } from './component/lms-tabs/lms-tabs.component';
import { LmsTerminalStatusSubmenuComponent } from './component/lms-terminal-status-submenu/lms-terminal-status-submenu.component';
import { LmsUserInfoComponent } from './component/lms-user-info/lms-user-info.component';
import { LmsUserProfileWindowComponent } from './component/lms-user-profile-window/lms-user-profile-window.component';
import { LmsUserProfileComponent } from './component/lms-user-profile/lms-user-profile.component';
import { StickyDirective } from './directives/sticky.directive';
import { AppUtilityService } from './services/app-utility.service';
import { CanActivateService } from './services/can-activate.service';
import { CanDeactivateViaEditGuardService } from './services/can-deactivate-via-edit-guard.service';
import { CommonPickListService } from './services/common-picklist.service';
import { ConfigService } from './services/config.service';
import { ContextMenuOperationsService } from './services/context-menu-operations.service';
import { DataStoreService } from './services/datastore.service';
import { EditModeService } from './services/edit-mode.service';
import { IntendedUsageService } from './services/intended-usage-service';
import { LmsLoaderService } from './services/lms-loader.service';
import { LmsLoggerService } from './services/lms-logger.service';
import { LmsMenuService } from './services/lms-menu.service';
import { LmsModuleService } from './services/lms-module.service';
import { LmsRendererService } from './services/lms-renderer.service';
import { LmsTabsDragDropService } from './services/lms-tabs-drag-drop.service';
import { LmsTerminalStatusSubmenuService } from './services/lms-terminal-status-submenu.service';
import { LocoIncidentService } from './services/loco-incident-service';
import { MasterDataService } from './services/master-data.service';
import { MessageHandlerService } from './services/message-handler.service';
import { PageResetService } from './services/page-reset.service';
import { PopupService } from './services/popup.service';
import { RouteChangePopupService } from './services/route-change-popup.service';
import { StaticDataStoreService } from './services/static-datastore.service';
import { SystemInitService } from './services/system-init.service';
import { TabService } from './services/tab.service';
import { UserConfigService } from './services/user-config.service';
import { UserProfileService } from './services/user-profile.service';
import { UserService } from './services/user.service';
import { UtilService } from './services/util.service';
import { LmsTonnageComponent } from './component/lms-tonnage/lms-tonnage.component';
import { LmsTonnageLmtoTableComponent } from './component/lms-tonnage/lms-tonnage-lmto-table/lms-tonnage-lmto-table.component';
import { LmsTonnageLmpsTableComponent } from './component/lms-tonnage/lms-tonnage-lmps-table/lms-tonnage-lmps-table.component';
import { LmsTonnageRatingsComponent } from './component/lms-tonnage/lms-tonnage-ratings/lms-tonnage-ratings.component';
import { ExportExcelService } from './services/export-excel.service';
import { AllDivisionsExportExcelService } from './services/all-divisions-export-excel.service';
import { AllDivisionsExportPDFService } from './services/all-divisions-export-pdf.service';










/**
 * @export
 * @class CoreModule
 */
@NgModule({
  imports: [
    CommonModule,
    CarouselModule,
    FormsModule,
    OverlayPanelModule,
    RouterModule,
    BrowserAnimationsModule,
    AutoCompleteModule,
    DropdownModule,
    DialogModule,
    RadioButtonModule,
    SpinnerModule,
    CheckboxModule,
    InputTextModule,
    TableModule,
    ReactiveFormsModule,
  ],
  declarations: [LmsHeaderComponent,
    LmsSideNavigationComponent,
    LmsTabsComponent,
    LmsMenuItemComponent,
    LmsFooterComponent,
    LmsSubmenuItemComponent,
    LmsTabComponent,
    LmsUserInfoComponent,
    LmsSearchPanelComponent,
    LmsTerminalStatusSubmenuComponent,
    LmsPageComponent,
    LmsMessageComponent,
    StickyDirective,
    LmsUserProfileComponent,
    DialogOperationComponent,
    LmsUserProfileWindowComponent,
    LmsBreExceptionComponent,
    LmsIntendedUsageComponent,
    LmsLocoUpdateIntUsageComponent,
    LmsDropdownComponent,
    AutocompleteComponent,
    LmsCarouselComponent,
    LmsTonnageComponent,
    LmsTonnageLmtoTableComponent,
    LmsTonnageLmpsTableComponent,
    LmsTonnageRatingsComponent],

  providers: [UtilService,
    DataStoreService,
    StaticDataStoreService,
    { provide: 'API_URL', useValue: 'api' },
    ConfigService,
    LmsMenuService,
    LmsLoggerService,
    MessageHandlerService,
    LmsTabsDragDropService,
    UserService,
    LmsTerminalStatusSubmenuService,
    SystemInitService,
    TabService,
    UserProfileService,
    LmsModuleService,
    LmsLoaderService,
    EditModeService,
    RouteChangePopupService,
    CanDeactivateViaEditGuardService,
    CanActivateService,
    PopupService,
    UserConfigService,
    PageResetService,
    AppUtilityService,
    MasterDataService,
    CommonPickListService,
    ContextMenuOperationsService,
    LmsRendererService,
    IntendedUsageService,
    LocoIncidentService,
    ExportExcelService,
    AllDivisionsExportExcelService,
    AllDivisionsExportPDFService],

  exports: [
    LmsHeaderComponent,
    LmsSideNavigationComponent,
    LmsTabsComponent,
    LmsFooterComponent,
    LmsPageComponent,
    LmsMessageComponent,
    RouterModule,
    BrowserAnimationsModule,
    StickyDirective,
    LmsBreExceptionComponent,
    LmsIntendedUsageComponent,
    LmsLocoUpdateIntUsageComponent,
    LmsDropdownComponent,
    AutocompleteComponent,
    LmsTonnageComponent,
  ]
})
export class CoreModule { }
